<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroAI') }}:
                |
                | {{ restricao?.numero_ai_ || restricao?.properties?.numero_ai_ || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.processo') }}:
                |
                | {{ restricao?.processo || restricao?.properties?.processo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataEntrada') }}:
                |
                | {{ restricao?.data_entra || restricao?.properties?.data_entra || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nomeAutuado') }}:
                |
                | {{ restricao?.nome_autua || restricao?.properties?.nome_autua || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.medida') }}:
                |
                | {{ restricao?.medida || restricao?.properties?.medida || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.unidadeDeMedida') }}:
                |
                | {{ restricao?.unidade_me || restricao?.properties?.unidade_me || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municipio') }}:
                |
                | {{ restricao?.municipio || restricao?.properties?.municipio || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.descricaoConstatacao') }}:
                |
                | {{ restricao?.descricao_ || restricao?.properties?.descricao_ || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.latitude') }}:
                |
                | {{ restricao?.latitude || restricao?.properties?.latitude || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.longitude') }}:
                |
                | {{ restricao?.longitude || restricao?.properties?.longitude || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.penaId') }}:
                |
                | {{ restricao?.pena_id || restricao?.properties?.pena_id || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.descricao') }}:
                |
                | {{ restricao?.descricao || restricao?.properties?.descricao || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataFimPenalidade') }}:
                |
                | {{ restricao?.data_fim_p || restricao?.properties?.data_fim_p || '-' }}
                br
                Criticidade(
                    v-if='restricao.nivelAlerta',
                    :restricao='restricao'
                )
</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
export default {
    name: 'area-embargada-rs',

    emits: ['highlightGeometry'],

    data() {
        return {};
    },

    components: {
        Criticidade
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        dataFormatada(data) {
            if (data && data.length > 0) {
                let ano = data.substring(0, 4);
                let mes = data.substring(5, 7);
                let dia = data.substring(8, 10);

                return dia + '/' + mes + '/' + ano;
            } else {
                return '-';
            }
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },

        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        }
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
